import React from 'react';
import ServicesBanner from '@/components/trinity/ServicesBanner';
import ImplantSolutionsSection from '@/components/trinity/ImplantSolutionsSection';
import AboutSection from '@/components/trinity/AboutSection';
import DrCredentials from '@/components/trinity/DrCredentials';
import SmileGallery from '@/components/trinity/SmileGallery';
import Testimonials from '@/components/trinity/Testimonials';
import HomeFAQ from '@/components/trinity/HomeFAQ';
import ConsultationForm from '@/components/trinity/ConsultationForm';

/**
 * Every below-the-fold homepage section in one lazily loaded module.
 *
 * Each section used to be its own React.lazy() root, which meant eight
 * parallel dynamic imports plus the handful of shared chunks they pull in,
 * all fired at once right after first paint. On a throttled mobile
 * connection that queue, not the bytes, was what pushed the last request
 * out past 2.4 s. Static imports here collapse that into a single request
 * for the sections and leave the shared chunks (Testimonials,
 * ConsultationForm) deduplicated by Rollup.
 */
export default function HomeBody() {
  return (
    <>
      <ServicesBanner />
      <ImplantSolutionsSection />
      <AboutSection />
      <DrCredentials />
      <SmileGallery />
      <Testimonials />
      <HomeFAQ />
      <ConsultationForm />
    </>
  );
}